import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { heroChips } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-68" data-mp="ehtkhzt5b7pe">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" style={{
      paddingTop: "5px"
    }} data-id="element-69" data-mp="9ll9mylze0o1">
        <h1 className="mx-auto mt-2 max-w-2xl font-display text-[23px] font-black uppercase leading-tight text-plum sm:text-[34px]" style={{
        paddingTop: "8px",
        marginTop: "-10px",
        marginBottom: "-10px"
      }} data-id="element-70" data-mp="4n1j0kwg00pc">
          Finish your <span className="text-grape" data-id="element-71" data-mp="x8jm7l6zcogo">corrections reports</span> in <span className="text-blush" data-id="element-72" data-mp="s9zz3hgnh6mq">minutes</span>, not hours
        </h1>

        <p className="pb-5 pt-3 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-plum/60 sm:text-sm" style={{
        paddingTop: "17px",
        paddingBottom: "10px"
      }} data-id="element-73" data-mp="ncq47mahs2ri">
          120 ready-to-use AI prompts for incident reports, use of force, logs, counts, write-ups and handovers
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-74" data-mp="3j893p1w0vrk9">
          <img src="https://cdn.magicpatterns.com/uploads/9K4Aus86E3vWsxfuqRzejg/Paquete_Sigma_Smart_para_Correcciones.webp" alt="Sigma Smart 100+ AI Prompts for Corrections Officers bundle with 4 free bonuses" className="mx-auto w-full" data-id="element-75" data-mp="39cfmh57cz9w5" />
        </motion.div>

        <p className="mt-4 text-[10px] font-semibold uppercase tracking-[0.18em] text-plum/50" data-id="element-76" data-mp="359szbhlmud5a">
          100+ AI PROMPTS FOR CORRECTIONS OFFICERS™ — 6 Volumes + 4 Bonuses · The SIGMA SMART™ Method · ⚡ Instant Access
        </p>

        <div className="mt-8 flex flex-col items-center" data-id="element-77" data-mp="2vj7sj6vt22ba">
          <CTAButton href="#pricing" data-id="element-78" data-mp="2hix224yeqpqn">See the 100+ AI Prompts for Corrections Officers</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-79" data-mp="2ll0gn2gdiag5">
            <span className="font-bold text-plum" data-id="element-80" data-mp="s2jnhxye22k1">BUILT FOR THE PEOPLE WHO RUN THE UNIT.</span> Designed for Corrections Officers,
            Jailers, Detention Deputies, Prison Officers and Sergeants who need clear, objective and fast
            documentation, shift after shift.
          </p>

          <h2 className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-grape-deep sm:text-xl" data-id="element-81" data-mp="ddf082cql852">
            Incidents · Use of Force · Logs & Counts · Write-Ups · Searches · Career
          </h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-82" data-mp="161axp9a4r42w">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/80 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-83" data-mp="111eqz2a1syjn">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-84" data-mp="3lt756pxsnptq" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-85" data-mp="3hqkbsklh5wuf">
            - Everything you need in one single toolkit -
          </p>
        </div>
      </div>
    </header>;
}